/**
 * A list's pager, for the end of a filter row: where the page sits in the total, back and forward, and a
 * box in the centre to type the page to go to. Its controls stand as tall as the row's fields. Shared by
 * the Library and Tagging's Browse tab.
 */
import { useEffect, useState } from 'react';
import { Icon } from '@/components/icons';

export function Pager({ page, pageSize, total, onPage }: {
  page: number;
  pageSize: number;
  total: number;
  onPage: (page: number) => void;
}) {
  const pages = pageCount(total, pageSize);
  const [draft, setDraft] = useState(String(page));
  useEffect(() => setDraft(String(page)), [page]);
  const go = () => {
    const n = Math.round(Number(draft));
    if (Number.isFinite(n) && n >= 1) onPage(Math.min(n, pages));
    else setDraft(String(page));
  };
  return (
    <div className="row pager">
      <span className="sub">Showing {(page - 1) * pageSize + 1}–{Math.min(page * pageSize, total)} of {total}</span>
      <button type="button" className="field pager-step" aria-label="Previous page" title="Previous page" disabled={page <= 1} onClick={() => onPage(page - 1)}>
        <Icon name="chev-l" />
      </button>
      <label className="row pager-field">
        Page
        <input className="field pager-input" type="number" min={1} max={pages} value={draft} aria-label="Page number"
          onChange={(e) => setDraft(e.target.value)} onBlur={go} onKeyDown={(e) => { if (e.key === 'Enter') go(); }} />
        of {pages}
      </label>
      <button type="button" className="field pager-step" aria-label="Next page" title="Next page" disabled={page >= pages} onClick={() => onPage(page + 1)}>
        <Icon name="chev-r" />
      </button>
    </div>
  );
}

/** How many pages a total fills; an empty list is still one page. */
export function pageCount(total: number, pageSize: number): number {
  return Math.max(1, Math.ceil(total / Math.max(1, pageSize)));
}
